import { render, staticRenderFns } from "./ActivityDialog.vue?vue&type=template&id=1013c54d&"
import script from "./ActivityDialog.vue?vue&type=script&lang=js&"
export * from "./ActivityDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports